import { forwardRef, type HTMLAttributes } from 'react';
import { cn } from './cn';

/**
 * `.ncard` from the supplied design: a bordered white panel that lifts on hover. The lift
 * is a `transform`, which the global `prefers-reduced-motion` rule neutralises without
 * this component knowing about it.
 */
export const Card = forwardRef<
  HTMLDivElement,
  HTMLAttributes<HTMLDivElement> & {
    interactive?: boolean;
    /**
     * The element to render. A card carrying one story is an `<article>` — that is what
     * HTML means by the word, and what lets a screen reader enumerate the stories on a
     * listing page rather than hearing a stack of anonymous boxes.
     */
    as?: 'div' | 'article';
  }
>(function Card({ interactive = false, as: Tag = 'div', className, ...props }, ref) {
  return (
    <Tag
      ref={ref}
      className={cn(
        'flex flex-col overflow-hidden rounded-lg border border-line bg-white',
        interactive && 'transition hover:-translate-y-0.5 hover:shadow-card',
        className,
      )}
      {...props}
    />
  );
});

export function CardBody({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('flex flex-1 flex-col px-4 pb-4 pt-3.5', className)} {...props} />;
}
